import React from "react";
import { ItemsView } from "../views/items/ItemsView.tsx";
import { SidebarProvider } from "@/components/ui/sidebar.tsx";
import { AppSidebar } from "@/blocks/AppSidebar.tsx";
import { Dialogs } from "@/dialogs/Dialogs.tsx";
import { useCurrentList } from "@/hooks/lists.ts";
import { uiState } from "@/states.ts";

const DesktopPage: React.FC = (props) => {
	const currentList = useCurrentList(false);

	//  we need to hide this page via css if we detect less than md (the isMobile breakpoint) because otherwise
	// on mobile we get a flash of the desktop before it's loaded
	return (
		<div className={"hidden md:block"}>
			<SidebarProvider>
				<Dialogs />
				<AppSidebar />
				<main className={"w-full py-4"}>
					{currentList ? (
						<div className={"flex justify-center flex-1"}>
							<div
								className={
									"w-full max-w-[800px] px-4"
								}
							>
								<ItemsView
									listId={currentList.id}
								/>
							</div>
						</div>
					) : (
						<div
							className={
								"flex justify-center items-center h-full"
							}
						>
							<div
								className={
									"bg-secondary rounded text-xl p-4 text-opacity-60 cursor-pointer"
								}
								onClick={() =>
									(uiState.newList = true)
								}
							>
								Get started by creating a list.{" "}
								<br />
								Click here or the + in the sidebar.
							</div>
						</div>
					)}
				</main>
			</SidebarProvider>
		</div>
	);
};

export { DesktopPage };
